import React, { Component } from 'react';
import map from 'lodash.map';
import { ActElementTr } from './ActElementTr';
import orderBy from 'lodash.orderby';
import { ActComments } from './ActComments';

export class ActElementTable extends Component {
	render() {
		const {
			childrens,
			showComment,
			canCommentAndSetOpinion,
			agreementAccepted = false,
			agreementAcceptedRequired = false,
			scrollToAgreement = Function.prototype,
			userId,
			showOpinion = false,
			addCommentOpinion,
			removeCommentOpinion,
			projectId,
			isCommentAdding = false
		} = this.props;

		return (
			<ActComments
				{...this.props}
				showComment={showComment}
				saveComment={(comment) => this.props.saveComment(comment)}
				canCommentAndSetOpinion={canCommentAndSetOpinion}
				addCommentOpinion={addCommentOpinion}
				removeCommentOpinion={removeCommentOpinion}
				projectId={projectId}
				agreementAccepted={agreementAccepted}
				agreementAcceptedRequired={agreementAcceptedRequired}
				scrollToAgreement={scrollToAgreement}
				userId={userId}
				showOpinion={showOpinion}
				isCommentAdding={isCommentAdding}
			>
				<table
					style={{
						borderCollapse: 'collapse'
					}}
				>
					{map(
						orderBy(childrens, (c) => c.order),
						(child) =>
							child.name === 'wiersz' ? (
								<ActElementTr
									showComment={showComment}
									saveComment={(comment) => this.props.saveComment(comment)}
									canCommentAndSetOpinion={canCommentAndSetOpinion}
									addCommentOpinion={addCommentOpinion}
									removeCommentOpinion={removeCommentOpinion}
									projectId={projectId}
									agreementAccepted={agreementAccepted}
									agreementAcceptedRequired={agreementAcceptedRequired}
									scrollToAgreement={scrollToAgreement}
									userId={userId}
									showOpinion={showOpinion}
									isCommentAdding={isCommentAdding}
									{...child}
								/>
							) : (
								<div />
							)
					)}
				</table>
			</ActComments>
		);
	}
}
